import React from "react";
import { Button, Col } from "react-bootstrap";
import jsPDF from "jspdf";

import "./Buttons.css";
import autoTable from "jspdf-autotable";

function BtnDownloadTable({
  size,
  data,
  label,
  fileName,
  pdfHeader,
  pdfFooter,
  orientation = "portrait",
}) {
  const handleDownload = () => {
    const doc = new jsPDF({ orientation });
    if (pdfHeader && pdfHeader.title && pdfHeader.content) {
      doc.setFontSize(18);
      doc.text(pdfHeader.title, 14, 22);
      doc.setFontSize(10);
      doc.setTextColor(100);

      var pageSize = doc.internal.pageSize;
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
      var content = doc.splitTextToSize(pdfHeader.content, pageWidth - 35, {});
      doc.text(content, 14, 30);
    }

    if (data.body.length > 0) {
      autoTable(doc, {
        ...data,
        styles: { fontSize: 8, cellPadding: 1 },
        headStyles: { fillColor: [41, 168, 223] },
        theme: "grid",
        startY: 40,
        showHead: "firstPage",
        didParseCell: function (data) {
          if (data.column.dataKey === "raw_color_tag") {
            const value = data.cell.raw;
            if (value === "hmo") {
              data.cell.styles.fillColor = [39, 61, 233]; // blue
            } else if (value === "gmc-mg") {
              data.cell.styles.fillColor = [250, 140, 22]; // orange
            } else if (value === "corporate") {
              data.cell.styles.fillColor = [250, 219, 20]; // yellow
            } else {
              data.cell.styles.fillColor = [255, 255, 255]; // white or transparent
            }

            // Optional: hide text to show only color
            data.cell.text = [""];
          }
        },
      });
    } else {
      doc.text(`No data to show.`, 14, 50);
    }

    if (data.body.length > 0 && pdfFooter) {
      doc.text(pdfFooter.content, 14, doc.lastAutoTable.finalY + 10);
    }

    doc.save(fileName);
  };

  return (
    <Col className="p-1">
      <Button className="action-btn clear" size={size} onClick={handleDownload}>
        {label || "Download PDF"}
      </Button>
    </Col>
  );
}

export default BtnDownloadTable;
